export default "__VITE_ASSET__07fb085e__"